export default "__VITE_ASSET__30549c53__"